import React from 'react';
import { Compass } from 'lucide-react';
export function FreeTrialExpectations() {
  return <section className="py-24 bg-ink text-off-white" data-id="element-1499">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1500">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1501">
          <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1502">
            <Compass className="w-3.5 h-3.5" data-id="element-1503" />
            Your First Visit
          </div>
          <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-1504">
            What to Expect
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1505">
            Showing up for the first time can feel intimidating. Here's exactly
            how Storm makes sure it isn't.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-1506">
          {[{
          step: '1',
          title: 'Submit the Form',
          desc: "Tell us a bit about you and what you're interested in. Takes about 30 seconds."
        }, {
          step: '2',
          title: 'Storm Will Reach Out',
          desc: 'A coach will help you pick the best starting class for your age and goals — before your first visit.'
        }, {
          step: '3',
          title: 'Show Up & Train',
          desc: 'Wear athletic clothes. Bare feet on the mat. No uniform or experience needed for your trial class.'
        }].map((s, i) => <div key={i} className="bg-charcoal/50 border border-charcoal rounded-2xl p-6 flex flex-col gap-3" data-id="element-1507">
              <div className="w-10 h-10 rounded-full bg-storm-red text-white font-bold flex items-center justify-center" data-id="element-1508">
                {s.step}
              </div>
              <h3 className="text-lg text-white" data-id="element-1509">{s.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-1510">{s.desc}</p>
            </div>)}
        </div>

        <div className="text-center mt-10" data-id="element-1511">
          <a href="#hero-form" className="btn-primary" data-id="element-1512">
            Check Availability
          </a>
        </div>
      </div>
    </section>;
}